export const PAYPAL_ERROR_TYPES = {
	WINDOW_UNAVAILABLE: 'window_unavailable',
	APP_SWITCH_RESUME: 'app_switch_resume',
	APPROVE: 'approve',
	BUTTON: 'button',
	RENDER: 'render',
	RENDER_BEFORE_READY: 'render_before_ready',
	SDK_INIT: 'sdk_init',
} as const;

export const QUERY_PARAM_KEYS = {
	ABCM_TOKEN: 'abcm_token',
	PAYPAL_REDIRECT_FLAG: 'pp_app_switch',
	TOKEN: 'token',
};
